import { create } from "zustand";

/**
 * User Store - Pure State Management
 * API calls are handled by UserIntegration
 */
export const useUserStore = create((set) => ({
  // State
  users: [],
  usersForDropdown: [],
  loading: false,
  error: null,
  selectedUser: null,
  searchQuery: "",
  filters: {},
  paginationData: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 10,
    hasNextPage: false,
    hasPreviousPage: false,
  },
  sortConfig: {
    key: "createdAt",
    direction: "desc",
  },
  columnFilters: {},
  uniqueValues: {},

  /** Mirrors last list request (for export / URL sync) */
  searchParams: {
    page: 1,
    pageSize: 10,
    search: '',
    sortBy: 'createdAt',
    sortOrder: 'desc',
    columnFilters: {},
  },

  // Setters
  setUsers: (users) => set({ users }),
  setUsersForDropdown: (users) => set({ usersForDropdown: users }),

  setLoading: (loading) => set({ loading }),

  setError: (error) => set({ error }),
  clearError: () => set({ error: null }),

  setSelectedUser: (user) => set({ selectedUser: user }),

  setSearchQuery: (query) => set({ searchQuery: query }),

  setFilters: (newFilters) =>
    set((state) => ({ filters: { ...state.filters, ...newFilters } })),

  setPaginationData: (paginationData) => set({ paginationData }),

  setSortConfig: (sortConfig) => set({ sortConfig }),

  setColumnFilters: (columnFilters) => set({ columnFilters }),

  setUniqueValues: (uniqueValues) => set({ uniqueValues }),

  setSearchParams: (patch) =>
    set((state) => ({
      searchParams: { ...state.searchParams, ...patch },
    })),


  reset: () => set({
    users: [],
    usersForDropdown: [],
    loading: false,
    error: null,
    selectedUser: null,
    searchQuery: "",
    filters: {},
    columnFilters: {},
    uniqueValues: {},
    searchParams: {
      page: 1,
      pageSize: 10,
      search: '',
      sortBy: 'createdAt',
      sortOrder: 'desc',
      columnFilters: {},
    },
    paginationData: {
      currentPage: 1,
      totalPages: 1,
      totalItems: 0,
      itemsPerPage: 10,
      hasNextPage: false,
      hasPreviousPage: false,
    },
    sortConfig: {
      key: "createdAt",
      direction: "desc",
    },
  })
}));
